import { cisStatic } from '../../cisService/api';
import Cookies from 'js-cookie';

const suv = Cookies.get('SUV') || '';
function params(spm) {
  return {
    clientType: 3,
    pvId: suv,
    requestId: genRequestId(),
    refererSpm: spm,
    refererPath: window.location.pathname,
    referSpm: getQueryString('spm') || '',
    referPath:window.document.referrer ? '/' + window.document.referrer.replace(/\?+[^?]*$/,'').split('/').slice(3).join('/') : '',
    sceneParam:[{
      page: 1,
      size: 10,
      spm: spm,
    }]
  }
}

function getQueryString(name) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  var r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return '';
}

function genRequestId() {
  var rands = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
  var arr = new Array(7);
  for (var i = 0; i < arr.length; i++) {
    arr[i] = rands[parseInt(Math.random() * rands.length, 0)];
  }
  var requestId = Date.now() + '_' + arr.join('');
  return requestId;
}

export const minFestival = ()  => {
  const spm = 'smpc.home-classic.top-festival';
  cisStatic(params(spm)).then(res => {
    const data = res[spm].data[0].resourceData.data.content[0];
    const bg = data.bg;
    const start = data.startTime;
    const end = data.endTime;
    if (+new Date() > (new Date(start).getTime()) && +new Date() < (new Date(end).getTime())) {
      document.querySelector('.input_SearchInput').style.width='257px';
      document.querySelector('.input_SearchInput').style.marginLeft='163px';
      document.querySelector('.searchBox_HomeSearchBox').style.background='#fff url(' + bg + ') no-repeat';
      document.querySelector('.searchBox_HomeSearchBox').style.backgroundSize='contain';
    }
  })
}

export const bigFestival = () => {
  const spm = 'smpc.home-classic.piaohong';
  cisStatic(params(spm)).then(res => {
    const data = res[spm].data[0].resourceData.data.content[0];
    const bg = data.bg;
    const start = data.startTime;
    const end = data.endTime;
    if (+new Date() > (new Date(start).getTime()) && +new Date() < (new Date(end).getTime())) {
      document.querySelector('.container_HomePage').style.background='#fff url(' + bg + ') no-repeat center 0';
      document.querySelector('.container_HomePage').style.backgroundSize='2600px auto';
      document.querySelector('.container_ClassicHomeNav').style.paddingTop='44px';
      document.querySelector('.btn_UserReport').style.backgroundColor="#ffd200";
      document.querySelector('.btn-text_UserReport').style.color="#ea3431";
      document.querySelector('#scroll-top.btn_UserReport').style.backgroundColor="#ff2828";
      document.querySelector('#scroll-top.btn_UserReport').style.color="#fff";
      //大皮肤切图中间空白未居中，故此整体右移2px以作兼容
      // document.querySelector('.container_ClassicHomeNav').style.transform="translate(2px,0)";
      // document.querySelector('.layer_HomePage').style.transform="translate(2px,0)";
    }
  })
}


// WEBPACK FOOTER //
// ./src/JS/cisFeed/festival.js